import styled from "styled-components";
import InnerMarkdownHTML from "../../../../../../base/text/inner-markdown-HTML/index.js";
import { AccordionContainer, AccordionHeader } from "../../../../../../structures/others/accordion/styled.js";
import Modal from "../../../../../../structures/others/modal/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { Padding } from "../../../../../../../styles/common/mixins/logical.styled.js";
export const ModalWrapper = styled(Modal).withConfig({
    displayName: "styled__ModalWrapper",
    componentId: "sc-3f867634-0"
})`
	overflow-y: auto;
	padding-bottom: 10px;
	--color-gray: ${({ theme  })=>theme.colors.grays.lighter};
`;
export const Body = styled.div.withConfig({
    displayName: "styled__Body",
    componentId: "sc-3f867634-1"
})`
	padding: 0;
	width: 100%;
	${FlexMixin()}
	max-height: none;
`;
export const Info = styled.div.withConfig({
    displayName: "styled__Info",
    componentId: "sc-3f867634-2"
})`
	width: 50%;
	position: relative;
	border-right: ${({ $isActivities  })=>!$isActivities && '1px solid var(--color-gray)'};
	color: ${({ theme  })=>theme.colors.grays.darker};
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'small'
})}
`;
export const InfoImage = styled.div.withConfig({
    displayName: "styled__InfoImage",
    componentId: "sc-3f867634-3"
})`
	position: relative;
	width: 100%;
	&:last-child {
		height: 100%;
	}
	min-height: 210px;
	${FlexMixin()}
	&:last-child img {
		min-width: 100%;
		min-height: 100%;
		object-fit: cover;
	}
	${({ $isActivities  })=>$isActivities && Padding({
        all: '10px'
    })}
`;
export const InfoHead = styled.p.withConfig({
    displayName: "styled__InfoHead",
    componentId: "sc-3f867634-4"
})`
	text-align: left;
	margin: 32px 16px 12px 16px;
	${FontMixin({
    size: 'base',
    weight: 'medium',
    height: 'base'
})}
`;
export const AccordionWrapper = styled.div.withConfig({
    displayName: "styled__AccordionWrapper",
    componentId: "sc-3f867634-5"
})`
	padding: 0 16px;

	${AccordionContainer}:last-child {
		border: none;
	}

	${AccordionHeader} {
		${FontMixin({
    size: 'base',
    weight: 'regular',
    height: 'large'
})}
		padding: 12px 0;
	}

	.title {
		${FontMixin({
    size: 'base',
    weight: 'medium',
    height: 'base'
})}
	}
`;
export const AccordionItem = styled.div.withConfig({
    displayName: "styled__AccordionItem",
    componentId: "sc-3f867634-6"
})`
	${FlexMixin({
    direction: 'column'
})}
	padding: 12px 0;
	padding-right: 32px;
	position: relative;

	&:first-child {
		padding-top: 0;
	}

	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;
export const AccordionHotelTitle = styled.p.withConfig({
    displayName: "styled__AccordionHotelTitle",
    componentId: "sc-3f867634-7"
})`
	${FlexMixin({
    align: 'center'
})}
	${FontMixin({
    size: 'base',
    weight: 'medium',
    height: 'base'
})}
	margin-bottom: 4px;

	i + i {
		margin-left: 2px;
	}

	& .hotel-title {
		margin-right: 4px;
	}
`;
export const AccordionContent = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__AccordionContent",
    componentId: "sc-3f867634-8"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})}

	& strong {
		${FontMixin({
    size: 'medium',
    weight: 'bold',
    height: 'base'
})}
	}
`;
export const Searcher = styled.div.withConfig({
    displayName: "styled__Searcher",
    componentId: "sc-3f867634-9"
})`
	width: 50%;
	position: relative;
`;
export const Footer = styled.div.withConfig({
    displayName: "styled__Footer",
    componentId: "sc-3f867634-10"
})`
	padding: 16px;
	border-top: 1px solid ${({ theme  })=>theme.colors.grays.light};
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
`;

//# sourceMappingURL=styled.js.map